import { useCallback, useEffect, useState } from "react";
import toast, { ToastOptions } from "react-hot-toast";

const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(typeof window !== "undefined" ? navigator.onLine : true);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const hasNetworkError = useCallback(
    (config?: { errorMessage?: string; options?: ToastOptions & { showToast?: boolean } }) => {
      const {
        errorMessage = "Network error detected. Please check your connection and try again",
        options
      } = config || {};
      const showToast = options?.showToast ?? true;

      if (!isOnline) {
        if (showToast) toast.error(errorMessage, options);
        return true;
      }
      return false;
    },
    [isOnline]
  );

  return { isOnline, hasNetworkError };
};

export default useNetworkStatus;
